<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <template>
            <v-card class="box" flat>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Notices
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox dense required v-model="academicyear" :items="ay_list" item-text="ay"
                            item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox dense required v-model="stream" :items="stream_list" item-text="name" label="Stream"
                            @change="get_divisions_stream(stream, 'stream')" outlined persistent-hint
                            hint="Please Select Stream" />
                    </v-col>
                    <v-col sm="1">
                        <br />
                        <center><strong>OR</strong></center>
                    </v-col>
                    <!-- <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete dense required v-model="standard" :items="standard_list_all"
                            item-text="standard" item-value="id" label="Standard" multiple
                            @change="get_divisions_stream(standard, 'standard')" outlined persistent-hint
                            hint="Please Select Standard"></v-autocomplete>
                    </v-col>
                    <v-col sm="2" v-if="division_list != ''">
                        <v-icon color="error">*</v-icon>
                        <v-combobox dense required v-model="division" :items="division_list" item-text="divname"
                            label="Division" outlined multiple />
                    </v-col> -->
                    <v-col cols="12" sm="2" md="2">
                        <v-icon color="error">*</v-icon>
                        <v-select dense required v-model="standard" :items="standard_list_all" item-text="standard"
                            item-value="id" outlined multiple @change="get_divisions_stream(standard, 'standard')"
                            persistent-hint hint="Please Select Standard">
                            <template #label>
                                Standard
                            </template>
                            <template v-slot:prepend-item>
                                <v-list-item @mousedown.prevent>
                                    <v-list-item-action>
                                        <v-checkbox v-model="selected_all_standard" @change="toggle_standard()">
                                            <template #label><span class="ml-8">Select All</span>
                                            </template>
                                        </v-checkbox>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete dense required v-model="division" :items="division_list" item-text="divname"
                            item-value="id" outlined multiple>
                            <template #label>
                                Division
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0">
                                    <span>{{ item.divname }}</span>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text text-caption">
                                    (+{{ division.length - 1 }} others)
                                </span>
                            </template>
                            <template v-slot:prepend-item>
                                <v-list-item @mousedown.prevent>
                                    <v-list-item-action>
                                        <v-checkbox v-model="selected_all_division" @change="toggle_division()">
                                            <template #label><span class="ml-8">Select All</span>
                                            </template>
                                        </v-checkbox>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <br />
                <!-- <v-row justify="center">
                     <v-col cols="12" sm="2">
                        <v-text-field outlined dense type="date" v-model="fromdate" label="From Date" hint="From Date"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                            <v-text-field outlined dense type="date" v-model="todate" label="To Date" hint="To Date"></v-text-field>
                    </v-col>
                     <v-col cols="12" sm="2">
                        <v-btn @click="fetchNotices()" :loading="send_btn_load" color="info">Fetch Notices</v-btn>
                     </v-col>
                </v-row> -->

                <span v-if="division != ''">
                    <v-row dense justify="center">
                        <v-col cols="6">
                            <v-text-field label="Title" v-model="title" :rules="textRule" required
                                placeholder="Enter Title....">
                                <template v-slot:prepend>
                                    <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
                                </template>

                                <!-- <v-icon color="red" size="15"> mdi-asterisk </v-icon> -->
                                <!-- <v-icon slot="prepend" :color="newClass.color.hex"> </v-icon> -->
                            </v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Link(If Any)" v-model="link" placeholder="URL"
                                @change="validateWebinarURL(link)"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-col cols="12">
                        <v-textarea label="Description" v-model="description" value placeholder="Enter Description...."
                            hint="Enter description of notice or home work"></v-textarea>
                    </v-col>
                    <v-col cols="12">
                        <v-file-input v-model="attachments" placeholder="Upload attachment if any" label="Attachment"
                            multiple prepend-icon="mdi-paperclip">
                            <template v-slot:selection="{ text }">
                                <v-chip small label color="primary">{{ text }}</v-chip>
                            </template>
                        </v-file-input>
                    </v-col>

                    <v-btn @click="putCalendar" :loading="send_btn_load" v-if="division && title" color="info"
                        :disabled="isvalid == false ? true : false">Send</v-btn>
                </span>
                <v-row v-if="!isvalid" align="center" justify="space-around">
                    <p v-if="!isvalid"><b>{{ Message }}</b></p>
                </v-row>
            </v-card>

            <v-card class="box" flat>
                <v-row justify="center">
                    <v-col cols="12" sm="2">
                        <!-- <p><v-icon color="error">*</v-icon><b>From Date</b></p> -->
                        <v-text-field outlined dense type="date" v-model="fromdate" label="From Date"
                            hint="From Date"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <!-- <p><v-icon color="error">*</v-icon><b>To Date</b></p> -->
                        <v-text-field outlined dense type="date" v-model="todate" label="To Date"
                            hint="To Date"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <!-- <p><br></p> -->
                        <v-btn @click="fetchNotices()" :loading="send_btn_load" color="info">Fetch Notices</v-btn>
                    </v-col>
                </v-row>


                <v-row dense justify="center" v-if="communication_list != ''">
                    <v-radio-group inline v-model="view" row>
                        <v-radio label="Single" value="Single"></v-radio>
                        <v-radio label="Cumulative" value="Cummalative"></v-radio>
                    </v-radio-group>
                </v-row>
            </v-card>
            <!-- <center> -->

            <!-- </center> -->
            <template v-if="view == 'Single'">
                <div v-if="communication_list.length != 0" class="pa-2">
                    <v-data-table :items="bookList1" :headers="headers" class="elevation-1 mytable" :search="search"
                        @current-items="getFiltered">
                        <template v-slot:top>
                            <v-toolbar flat color="white" justify="center">
                                <div>
                                    <div class="text-h2 font-weight-bold">
                                        List of Notices
                                    </div>
                                    <div class="caption grey--text">
                                        AY : {{ d_ay }} |
                                        {{ from_date }} - {{ to_date }}
                                    </div>
                                </div>

                                <v-spacer></v-spacer>
                                <!-- <v-text-field
                                       v-model="search"
                                       append-icon="search"
                                         label="Search"
                                          single-line
                                         hide-details
                                     ></v-text-field> -->

                                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" label="Search Notice"
                                    dense outlined rounded hide-details class="mr-4"
                                    style="max-width:280px"></v-text-field>

                                <v-btn outlined color="primary" class="mr-2" @click="print()" :loading="loader">
                                    <v-icon>mdi-printer</v-icon>

                                </v-btn>

                                <v-btn outlined color="success" @click="exportBookList1Data" :loading="loader">
                                    <v-icon>mdi-file-excel</v-icon>

                                </v-btn>
                            </v-toolbar>
                            <v-row dense class="px-3 pb-8">

                                <v-col v-for="header in headers" :key="header.value" cols="12" sm="3" md="2"
                                    v-if="filters.hasOwnProperty(header.value)">

                                    <v-autocomplete v-model="filters[header.value]"
                                        :items="columnValueList(header.value)" :label="header.text" multiple clearable
                                        dense outlined hide-details chips small-chips />

                                </v-col>

                            </v-row>
                        </template>
                        <template v-slot:[`item.description`]="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn small color="primary" outlined v-bind="attrs" v-on="on"
                                        @click="getDescription(item.description)">
                                        <v-icon left small>mdi-book-open-page-variant</v-icon>
                                        View
                                    </v-btn>
                                </template>
                                <span>View Description</span>
                            </v-tooltip>
                        </template>

                        <template v-slot:[`item.url`]="{ item }">
                            <a :href="item.url" target="_blank" v-if="item.url != '--'">
                                <v-icon class="mr-2 v-icon-size" color="deep-orange">mdi-link</v-icon>
                            </a>
                            <span v-else style="opacity: 0.5;">{{ item.url }}</span>
                        </template>
                        <template v-slot:[`item.attachment`]="{ item }">
                            <span v-if="item.attachment_list.length > 0">
                                <span v-for="(item, i) in item.attachment_list" :key="i">
                                    <a class="p-2" :href="basepath + item.link" target="blank">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ attrs }">
                                                <v-btn icon v-if="item.link != null" v-bind="attrs"> <v-icon
                                                        color="info">mdi-paperclip</v-icon></v-btn>
                                            </template>
                                            <span> View Attachment File!!! </span>
                                        </v-tooltip>
                                    </a>
                                </span>
                            </span>
                            <!-- </span>    -->
                        </template>
                        <!-- <template v-slot:[`item.edit`]="{ item }">
                                <div>
                                    <v-btn color="secondary" icon dark @click="editDialog(item)" title="Edit Event">
                                        <v-icon>mdi-file-document-edit</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                            <template v-slot:[`item.delete`]="{ item }">
                                <div>
                                    <v-btn color="warning" icon dark @click="deleteCalendarEvent(item)" title="Delete Event" :loading="delete_attach_load">
                                        <v-icon>mdi-delete-empty</v-icon>
                                    </v-btn>
                                </div>
                            </template> -->

                        <template v-slot:[`item.action`]="{ item }">

                            <div class="d-flex justify-center">

                                <v-tooltip top>

                                    <template v-slot:activator="{ on, attrs }">

                                        <v-btn icon color="indigo" v-bind="attrs" v-on="on" @click="editDialog(item)">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>

                                    </template>

                                    <span>Edit</span>

                                </v-tooltip>

                                <v-tooltip top>

                                    <template v-slot:activator="{ on, attrs }">

                                        <v-btn icon color="red" v-bind="attrs" v-on="on"
                                            @click="deleteCalendarEvent(item)">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>

                                    </template>

                                    <span>Delete</span>

                                </v-tooltip>

                                <v-tooltip top>

                                    <template v-slot:activator="{ on, attrs }">

                                        <v-btn icon color="green" v-bind="attrs" v-on="on" @click="getStatus(item.id)">
                                            <v-icon>mdi-eye</v-icon>
                                        </v-btn>

                                    </template>

                                    <span>Status</span>

                                </v-tooltip>

                                <v-tooltip top>

                                    <template v-slot:activator="{ on, attrs }">

                                        <v-btn icon color="orange" v-bind="attrs" v-on="on"
                                            @click="editwhenresendDialog(item)">
                                            <v-icon>mdi-refresh</v-icon>
                                        </v-btn>

                                    </template>

                                    <span>Resend Notice</span>

                                </v-tooltip>

                            </div>

                        </template>
                    </v-data-table>
                </div>
            </template>
            <template v-if="view == 'Cummalative'">
                <v-toolbar class="ma-2" flat color="white">
                    <v-spacer></v-spacer>
                    <v-text-field v-model="searchQuery" append-icon="mdi-magnify" label="Search Notices" outlined dense
                        rounded hide-details style="max-width:350px"></v-text-field>
                </v-toolbar>
                <v-row dense class="pa-2">
                    <v-col cols="12" v-for="(value, key) in cum_list" :key="key"
                        v-if="matchesSearch(value, searchQuery)">
                        <v-card class="pa-4 mb-4 elevation-2 rounded-lg notice-card">

                            <!-- Header -->
                            <v-row align="center" no-gutters>
                                <v-col cols="10">
                                    <div class="text-h6 font-weight-bold green--text text--darken-2">
                                        {{ value[0] }}
                                    </div>
                                </v-col>

                                <v-col cols="2" class="text-right">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon color="indigo" v-bind="attrs" v-on="on"
                                                @click="editCumulativeNotice(key)">
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit Notice</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon color="primary" v-bind="attrs" v-on="on"
                                                @click="getdataresendCumulative(key)">
                                                <v-icon>mdi-reload</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Resend Notice</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon color="error" :loading="delete_loader" v-bind="attrs" v-on="on"
                                                @click="deleteCommnByMsgId(key)">
                                                <v-icon>mdi-trash-can</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Delete Notice</span>
                                    </v-tooltip>

                                </v-col>
                            </v-row>

                            <v-divider class="my-3"></v-divider>

                            <!-- Description -->
                            <div class="grey--text text--darken-3 mb-3">
                                <strong>Description</strong><br>
                                {{ value[1] }}
                            </div>

                            <!-- Standards -->
                            <div class="font-weight-medium mb-2">
                                Sent To
                            </div>

                            <div>
                                <v-chip v-for="(std, ind) in value" :key="ind" v-if="ind > 1" class="ma-1"
                                    color="blue lighten-4" text-color="blue darken-3" small>
                                    {{ std }}
                                </v-chip>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </template>
            <v-dialog v-model="description_dialog" max-width="900px">
                <v-card class="pa-4">
                    <v-card-text v-html="show_description.replace(/\n/g, '<br>')"></v-card-text>
                    <v-card-actions class="justify-center"><v-btn color="warning"
                            @click="description_dialog = false">Close</v-btn></v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="status_dialog" max-width="1200px">
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="status_headers" :items="comm_read_status" :search="search"
                            @current-items="getFiltered" :items-per-page="-1">
                            <template v-slot:top>
                                <v-toolbar flat color="white" align="center" justify="center">
                                    <v-toolbar-title>List of Receipients</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <strong>Total Receipients- </strong>{{ total_receipients }}
                                    <v-spacer></v-spacer>
                                    <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                        hide-details></v-text-field>
                                </v-toolbar>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions class="justify-center"><v-btn class="dialog-btn"
                            @click="status_dialog = false">Close</v-btn></v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="edit_dialog" max-width="750" persistent scrollable>
                <v-card>
                    <v-toolbar color="primary" dark flat>
                        <v-icon left>mdi-file-document-edit-outline</v-icon>
                        <v-toolbar-title>Edit Notice</v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-btn icon @click="edit_dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-card-text class="pa-5">
                        <v-card outlined class="mb-2 pa-3">
                            <div class="subtitle-1 font-weight-bold mb-3">
                                Notice Information
                            </div>

                            <v-row>

                                <v-col cols="12" md="3">
                                    <v-text-field v-model="editedItem.date" label="Sent Date" dense outlined readonly
                                        hide-details />
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-text-field v-model="editedItem.from" label="From" dense outlined readonly
                                        hide-details />
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-text-field v-model="editedItem.to" label="To" dense outlined readonly
                                        hide-details />
                                </v-col>

                            </v-row>
                        </v-card>

                        <v-card outlined class="pa-3">

                            <div class="subtitle-1 font-weight-bold mb-3">
                                Edit Notice
                            </div>

                            <v-text-field v-model="editedItem.title" label="Title" outlined dense />

                            <v-text-field v-model="editedItem.url" label="Website / Link" outlined dense />

                            <v-textarea v-model="editedItem.description" label="Description" rows="5" outlined
                                auto-grow />

                            <v-file-input v-model="edit_attachments" label="Upload Attachments" outlined dense multiple>
                                <template v-slot:selection="{ text }">
                                    <v-chip small color="primary" dark class="mr-1">
                                        {{ text }}
                                    </v-chip>
                                </template>
                            </v-file-input>

                        </v-card>


                        <v-card outlined class="mt-4 pa-3" v-if="editedItem.attachment_list.length">

                            <div class="subtitle-1 font-weight-bold mb-2">
                                Existing Attachments
                            </div>

                            <v-chip v-for="attach in editedItem.attachment_list" :key="attach.attach_id" class="ma-2"
                                outlined>

                                <a :href="awspath + attach.link" target="_blank" class="text-decoration-none">
                                    {{ attach.attach_name }}
                                </a>

                                <v-icon small color="error" class="ml-2" @click="deleteAttachment(attach)">
                                    mdi-close-circle
                                </v-icon>

                            </v-chip>

                        </v-card>

                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="pa-4">

                        <v-spacer></v-spacer>

                        <v-btn outlined color="grey" @click="edit_dialog = false">
                            Cancel
                        </v-btn>

                        <v-btn color="primary" :loading="edit_save_attachment_load" @click="save">
                            <v-icon left>mdi-content-save</v-icon>
                            Save Changes
                        </v-btn>

                    </v-card-actions>

                </v-card>
            </v-dialog>
            <v-dialog v-model="edit_when_resend_dialog" max-width="750" persistent scrollable>
                <v-card>

                    <!-- Header -->
                    <v-toolbar color="warning" dark flat>
                        <v-icon left>mdi-refresh</v-icon>
                        <v-toolbar-title>Edit & Resend Notice</v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-btn icon @click="edit_when_resend_dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-card-text class="pa-5">
                        <v-card outlined class="mb-4 pa-3">

                            <div class="subtitle-1 font-weight-bold mb-3">
                                Notice Information
                            </div>

                            <v-row>

                                <v-col cols="12" md="3">
                                    <v-text-field v-model="editedItem.date" label="Sent Date" outlined dense readonly
                                        hide-details />
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-text-field v-model="editedItem.from" label="From" outlined dense readonly
                                        hide-details />
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-text-field v-model="editedItem.to" label="To" outlined dense readonly
                                        hide-details />
                                </v-col>

                            </v-row>

                        </v-card>

                        <v-card outlined class="pa-3">

                            <div class="subtitle-1 font-weight-bold mb-3">
                                Update Notice Before Resending
                            </div>

                            <v-text-field v-model="editedItem.title" label="Title" outlined dense />

                            <v-text-field v-model="editedItem.url" label="Website / Link" outlined dense />

                            <v-textarea v-model="editedItem.description" label="Description" outlined rows="5"
                                auto-grow />

                            <v-file-input v-model="edit_attachments" label="Add Attachments" outlined dense multiple
                                prepend-icon="mdi-paperclip">
                                <template v-slot:selection="{ text }">
                                    <v-chip small color="warning" dark class="mr-1">
                                        {{ text }}
                                    </v-chip>
                                </template>
                            </v-file-input>

                        </v-card>

                        <v-card outlined class="mt-4 pa-3" v-if="editedItem.attachment_list.length">

                            <div class="subtitle-1 font-weight-bold mb-3">
                                Existing Attachments
                            </div>

                            <v-chip v-for="attach in editedItem.attachment_list" :key="attach.attach_id" class="ma-2"
                                outlined color="primary">
                                <a :href="awspath + attach.link" target="_blank" style="text-decoration:none;">
                                    {{ attach.attach_name }}
                                </a>
                            </v-chip>

                        </v-card>

                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="pa-4">

                        <v-spacer></v-spacer>

                        <v-btn outlined color="grey" @click="edit_when_resend_dialog = false">
                            Cancel
                        </v-btn>

                        <v-btn color="warning" dark :loading="edit_when_resend_loader" @click="resend">
                            <v-icon left>mdi-refresh</v-icon>
                            Resend Notice
                        </v-btn>

                    </v-card-actions>

                </v-card>
            </v-dialog>
            <v-dialog v-model="edit_when_resend_comulative_dialog" max-width="750" persistent scrollable>
                <v-card>
                    <v-toolbar color="deep-orange" dark flat>
                        <v-icon left>mdi-refresh-circle</v-icon>
                        <v-toolbar-title>Edit & Resend Cumulative Notice</v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-btn icon @click="edit_when_resend_comulative_dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-card-text class="pa-5">

                        <v-card outlined class="mb-4 pa-3">

                            <div class="subtitle-1 font-weight-bold mb-3">
                                Notice Information
                            </div>

                            <v-row>

                                <v-col cols="12" md="3">
                                    <v-text-field v-model="editedItem_for_comulative_resend.date" label="Sent Date"
                                        outlined dense readonly hide-details />
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-text-field v-model="editedItem_for_comulative_resend.from" label="From" outlined
                                        dense readonly hide-details />
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-text-field v-model="editedItem_for_comulative_resend.to" label="Recipients"
                                        outlined dense readonly hide-details />
                                </v-col>

                            </v-row>

                        </v-card>

                        <v-card outlined class="pa-3">

                            <div class="subtitle-1 font-weight-bold mb-3">
                                Modify Notice Before Resending
                            </div>

                            <v-text-field v-model="editedItem_for_comulative_resend.title" label="Title" outlined
                                dense />

                            <v-text-field v-model="editedItem_for_comulative_resend.url" label="Website / Link" outlined
                                dense />

                            <v-textarea v-model="editedItem_for_comulative_resend.description" label="Description"
                                rows="5" outlined auto-grow />

                            <v-file-input v-model="edit_attachments" label="Upload Additional Attachments" outlined
                                dense multiple>
                                <template v-slot:selection="{ text }">
                                    <v-chip small color="deep-orange" dark class="mr-1">
                                        {{ text }}
                                    </v-chip>
                                </template>
                            </v-file-input>

                        </v-card>

                        <v-card outlined class="mt-4 pa-3"
                            v-if="editedItem_for_comulative_resend.attachment_list.length">

                            <div class="subtitle-1 font-weight-bold mb-3">
                                Existing Attachments
                            </div>

                            <v-chip v-for="attach in editedItem_for_comulative_resend.attachment_list"
                                :key="attach.attach_id" outlined color="primary" class="ma-2">
                                <a :href="basepath + attach.link" target="_blank" style="text-decoration:none;">
                                    {{ attach.attach_name }}
                                </a>
                            </v-chip>

                        </v-card>

                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="pa-4">

                        <v-spacer></v-spacer>

                        <v-btn outlined color="grey" @click="edit_when_resend_comulative_dialog = false">
                            Cancel
                        </v-btn>

                        <v-btn color="deep-orange" dark :loading="edit_when_resend_comulative_loader"
                            @click="resendCumulative()">
                            <v-icon left>mdi-refresh-circle</v-icon>
                            Resend Cumulative Notice
                        </v-btn>

                    </v-card-actions>

                </v-card>
            </v-dialog>
            <v-dialog v-model="edit_cumulative_dialog" max-width="750" persistent scrollable>
                <v-card>
                    <v-toolbar color="primary" dark flat>
                        <v-icon left>mdi-file-document-edit-outline</v-icon>
                        <v-toolbar-title>Edit Cumulative Notice</v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-btn icon @click="edit_cumulative_dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-card-text class="pa-5">
                        <v-card outlined class="pa-3">
                            <div class="subtitle-1 font-weight-bold mb-3">
                                Edit Notice
                            </div>

                            <v-text-field v-model="editedItem_for_cumulative_edit.title" label="Title" outlined dense />

                            <v-text-field v-model="editedItem_for_cumulative_edit.url" label="Website / Link" outlined
                                dense />

                            <v-textarea v-model="editedItem_for_cumulative_edit.description" label="Description"
                                rows="5" outlined auto-grow />

                            <v-file-input v-model="edit_attachments" label="Upload Additional Attachments" outlined
                                dense multiple prepend-icon="mdi-paperclip">
                                <template v-slot:selection="{ text }">
                                    <v-chip small color="primary" dark class="mr-1">
                                        {{ text }}
                                    </v-chip>
                                </template>
                            </v-file-input>
                        </v-card>

                        <v-card outlined class="mt-4 pa-3" v-if="editedItem_for_cumulative_edit.attachment_list.length">
                            <div class="subtitle-1 font-weight-bold mb-3">
                                Existing Attachments
                            </div>

                            <v-chip v-for="attach in editedItem_for_cumulative_edit.attachment_list"
                                :key="attach.attach_id" outlined color="primary" class="ma-2">
                                <a :href="basepath + attach.link" target="_blank" style="text-decoration: none;">
                                    {{ attach.attach_name }}
                                </a>
                            </v-chip>
                        </v-card>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="pa-4">
                        <v-spacer></v-spacer>

                        <v-btn outlined color="grey" @click="edit_cumulative_dialog = false">
                            Cancel
                        </v-btn>

                        <v-btn color="primary" :loading="edit_cumulative_loader" @click="saveCumulativeNotice">
                            <v-icon left>mdi-content-save</v-icon>
                            Save Changes
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


        </template>
        <div class="text-center">
            <v-dialog v-model="init_loader" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Please Wait
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        // extraBreadcrumbItems: [


        // ],
        breadcrumbClass: "breadcrumb-style1",
        isvalid: true, Message: null,
        file_upload_config: { allowed_type: "", max_size: 1000 },
        rules: [(value) => !value || value.size < 2000000 || "Logo size should be less than 2 MB!"],
        textRule: [(v) => !!v || "Field is required"],

        attachments: [],
        ay_list: [],
        academicyear: "",
        stream: "",
        stream_list: [],
        standard_list_all: [],
        standard: [],
        event_type_list: [],
        division_list: [],
        standard_list: [],
        division: [],
        selected_all_standard: false,
        selected_all_division: false,
        event_type: "",
        datetime: null,
        search: "",
        searchQuery: "",
        snackbar_msg: "",
        snackbar: false,
        color: "",
        communication_list: [],
        get_communication_list_for_resend: [],
        awspath: null,

        send_btn_load: false,
        delete_attach_load: false,
        basepath: "",
        description: "",
        link: "",
        edit_save_attachment_load: false,
        edit_attachments: [],
        filterArr: [],
        delete_acttach_load: false,
        filters: {
            // std: [],
            title: [],
            date: [],
            to: [],
            employeeName: [],
        },
        status_headers: [
            { text: "Sr No", value: "srno", sortable: true },
            { text: "Read By", value: "learner", sortable: true },
            { text: "Read Date", value: "read_date", sortable: true },
        ],
        headers: [
            { text: "Academic Year", value: "academicyear", sortable: true, align: 'center' },
            { text: "Sent Date", value: "date", sortable: true, align: 'center' },
            { text: "From", value: "from", sortable: true, align: 'center' },
            { text: "Employee Name", value: "employeeName", sortable: true, align: 'center' },
            { text: "To", value: "to", sortable: true, align: 'center' },
            { text: "Title", value: "title", sortable: true, align: 'center' },
            { text: "Description", value: "description", sortable: true, align: 'center' },
            { text: "Attachments", value: "attachment", sortable: true, align: 'center' },
            { text: "Link", value: "url", sortable: true, align: 'center' },
            { text: "Action", value: "action", sortable: true, align: 'center' },
        ],
        editedItem: {
            date: null,
            attachment_list: [],
            description: "",
            from: null,
            id: null,
            to: null,
            title: null,
            url: null,
        },
        editedItem_for_comulative_resend: {  // Add this to make it reactive
            title: '',
            url: '',
            description: '',
            attachment_list: [],
            date: ''
        },
        editedItem_for_cumulative_edit: {
            title: "", url: "",
            description: "",
            attachment_list: [],
            key: null
        },
        edit_cumulative_dialog: false,
        edit_cumulative_loader: false,
        //editItemIndex: -1,
        title: null,
        web_Link: "",
        edit_dialog: false,
        edit_when_resend_dialog: false,
        edit_when_resend_loader: false,
        edit_when_resend_comulative_dialog: false,
        edit_when_resend_comulative_loader: false,
        comm_read_status: [],
        status_dialog: false,
        description_dialog: false,
        show_description: "",
        total_receipients: "",
        //
        d_ay: null,
        // from_date: null,
        // to_date: null,
        init_loader: false,
        delete_loader: false,
        //
        view: "",
        cum_list: null,
        // fromdate: new Date().toISOString().slice(0, 10),
        fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
        todate: new Date().toISOString().slice(0, 10),
    }),
    watch: {},
    methods: {
        toggle_standard() {
            this.$nextTick().then(() => {
                if (this.selected_all_standard) {
                    this.standard = [];
                    for (var x in this.standard_list_all) {
                        this.standard.push(this.standard_list_all[x].id);
                    }
                    this.get_divisions_stream(this.standard, 'standard')
                } else {
                    this.standard = [];
                }
            });
        },
        toggle_division() {
            this.$nextTick().then(() => {
                if (this.selected_all_division) {
                    this.division = [];
                    for (var x in this.division_list) {
                        this.division.push(this.division_list[x].id);
                    }
                } else {
                    this.division = [];
                }
            });
        },

        print() {
            if (!this.bookList1 || this.bookList1.length === 0) {
                alert("No data to print");
                return;
            }

            let printWindow = window.open('', '', 'height=800,width=1100');

            let tableHeader = `<tr><th>Sr. No</th>`;
            this.headers.forEach(header => {
                if (header.value !== 'action' && header.value !== 'attachment') {
                    tableHeader += `<th>${header.text}</th>`;
                }
            });
            tableHeader += `</tr>`;

            let tableBody = this.bookList1.map((item, index) => {
                let row = `<tr><td>${index + 1}</td>`;
                this.headers.forEach(header => {
                    if (header.value !== 'action' && header.value !== 'attachment') {
                        let value = item[header.value] || '-';
                        if (header.value === 'url' && value !== '-') {
                            value = `<a href="${value}" target="_blank">${value}</a>`;
                        }
                        row += `<td>${value}</td>`;
                    }
                });
                row += `</tr>`;
                return row;
            }).join('');

            let html = `
    <html>
      <head>
        <title>List of Notices</title>
        <style>
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #000; padding: 8px; text-align: left; }
          th { background-color: #f2f2f2; }
        </style>
      </head>
      <body>
      
        <table>
          <thead>${tableHeader}</thead>
          <tbody>${tableBody}</tbody>
        </table>
      </body>
    </html>
  `;

            printWindow.document.write(html);
            printWindow.document.close();
            printWindow.print();
        },




        exportBookList1Data() {
            const exportData = this.bookList1.map((item, index) => ({
                "Sr. No.": index + 1,
                "Academicyear": item.academicyear || "-",
                "Sent Date": item.date || "-",
                "From": item.from || "-",
                "Employee Name": item.employeeName || "-",
                "To": item.to || "-",
                "Title": item.title || "-",
                "Description": item.description || "-",
                // "Attachments": item.attachment ? "Yes" : "No",
                "Link": item.url || "-",
            }));

            import("xlsx").then(XLSX => {
                const worksheet = XLSX.utils.json_to_sheet(exportData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "BookList1");
                XLSX.writeFile(workbook, "List of Notices.xlsx");
            });
        },
        editCumulativeNotice(key) {
            this.basepath = localStorage.getItem("awspath");
            this.edit_attachments = [];

            axios
                .post("/Communication/getdataresendNoticeHWAlbumCumulative", {
                    key: key
                })
                .then((res) => {
                    if (res.data.flag === "Yes") {
                        const item = res.data.communication_list[0];

                        this.editedItem_for_cumulative_edit = {
                            title: item.title || "",
                            url: item.url || "",
                            description: item.description || "",
                            attachment_list: item.attachment_list || [],
                            key: item.key || key
                        };

                        this.edit_cumulative_dialog = true;
                    } else {
                        this.showSnackbar(
                            "#b71c1c",
                            res.data.snackbar || "Unable to load notice."
                        );
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.showSnackbar("#b71c1c", "Something went wrong.");
                });
        },

        saveCumulativeNotice() {
            if (this.edit_cumulative_loader) {
                return
            }


            const notice = this.editedItem_for_cumulative_edit

            if (!notice || !notice.key) {
                this.color = "error"
                this.snackbar_msg = "Notice key is missing"
                this.snackbar = true
                return
            }

            if (!notice.title || !notice.title.trim()) {
                this.color = "error"
                this.snackbar_msg = "Please enter notice title"
                this.snackbar = true
                return
            }

            if (!notice.description || !notice.description.trim()) {
                this.color = "error"
                this.snackbar_msg = "Please enter notice description"
                this.snackbar = true
                return
            }

            const formData = new FormData()

            // These parameter names must match the Grails service.
            formData.append("key", notice.key)
            formData.append("title", notice.title.trim())
            formData.append("description", notice.description.trim())
            formData.append("link", notice.url || "")

            // Send newly selected attachments.
            if (this.edit_attachments && this.edit_attachments.length > 0) {
                this.edit_attachments.forEach(file => {
                    if (file instanceof File) {
                        formData.append("files", file)
                    }
                })
            }

            this.edit_cumulative_loader = true

           axios.post(
                    "/Communication/editNoticeHWAlbumCumulative",
                    formData,
                                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "EPS-token": localStorage.getItem("EPS-token"),
                        "EPS-uid": localStorage.getItem("EPS-uid"),
                        "router-path": window.location.pathname
                    }
                }
            )
                .then(res => {
                    const data = res.data || {}

                    if (
                        data.status === "SUCCESS" ||
                        data.flag === "YES"
                    ) {
                        this.color = "success"
                        this.snackbar_msg =
                            data.status_reason || "Notice updated successfully"
                        this.snackbar = true

                        this.edit_cumulative_dialog = false
                        this.edit_attachments = []

                        this.fetchNotices()
                    } else {
                        this.color = "error"
                        this.snackbar_msg =
                            data.status_reason ||
                            data.message ||
                            "Unable to update notice"
                        this.snackbar = true
                    }
                })
                .catch(error => {
                    console.error(
                        "Error updating cumulative notice:",
                        error.response || error
                    )

                    this.color = "error"
                    this.snackbar_msg =
                        (error.response &&
                            error.response.data &&
                            error.response.data.status_reason) ||
                        "Error while updating notice. Please try again."

                    this.snackbar = true
                })
                .finally(() => {
                    this.edit_cumulative_loader = false
                })


        },





        getdataresendCumulative(item) {

            const formData = {
                key: item

            };
            axios
                .post("/Communication/getdataresendNoticeHWAlbumCumulative", formData)
                .then((res) => {
                    if (res.data.flag == "Yes") {

                        this.get_communication_list_for_resend = res.data.communication_list[0];
                        this.editedItem_for_comulative_resend = {


                            title: this.get_communication_list_for_resend.title,
                            url: this.get_communication_list_for_resend.url,
                            from: this.get_communication_list_for_resend.from, // Add from field if needed
                            to: this.get_communication_list_for_resend.to, // Add from field if needed

                            description: this.get_communication_list_for_resend.description,
                            attachment_list: this.get_communication_list_for_resend.attachment_list,
                            date: this.get_communication_list_for_resend.date, // Add date if needed
                            key: this.get_communication_list_for_resend.key

                        };

                        // Open the dialog after populating data
                        this.edit_when_resend_comulative_dialog = true;

                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.init_loader = false;
                });
        },

        resendCumulative() {
            if (!confirm("Are You Sure You Want To Edit And Resend This Communication?")) return;
            this.init_loader = true
            this.edit_when_resend_comulative_loader = true
            let formData = new FormData();
            for (var i = 0; i < this.edit_attachments.length; i++) {
                let file = this.edit_attachments[i];

                formData.append("files", file);
            }
            formData.append("existing_attachments", JSON.stringify(this.editedItem_for_comulative_resend.attachment_list || []));
            formData.append("title", this.editedItem_for_comulative_resend.title);
            formData.append("link", this.editedItem_for_comulative_resend.url);
            formData.append("description", this.editedItem_for_comulative_resend.description);
            formData.append("key", this.editedItem_for_comulative_resend.key);
            axios
                .post("/Communication/resendNoticeHWAlbumCumulative", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Notice sent Successfully..."); // show snackbar on success
                        this.edit_when_resend_comulative_dialog = false;
                        this.edit_when_resend_comulative_loader = false;

                    }
                    if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.edit_when_resend_comulative_dialog = false;
                        this.edit_when_resend_comulative_loader = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                    this.edit_when_resend_comulative_dialog = false;
                    this.edit_when_resend_comulative_loader = false;
                })
                .finally(() => {
                    this.init_loader = false
                    this.get_ay_std();
                    this.fetchNotices();
                    this.edit_when_resend_comulative_dialog = false;
                    this.edit_when_resend_comulative_loader = false;
                });
        },
        resend() {
            if (!confirm("Are You Sure You Want To Edit And Resend This Communication?")) return;
            this.edit_when_resend_loader = true;
            this.init_loader = true
            let formData = new FormData();
            for (var i = 0; i < this.edit_attachments.length; i++) {
                let file = this.edit_attachments[i];

                formData.append("files", file);
            }
            formData.append("existing_attachments", JSON.stringify(this.editedItem.attachment_list || []));
            formData.append("title", this.editedItem.title);
            formData.append("link", this.editedItem.url);
            formData.append("description", this.editedItem.description);
            formData.append("comm_id", this.editedItem.id);
            axios
                .post("/Communication/resendNoticeHWAlbumSingle", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Notice Added Successfully..."); // show snackbar on success
                        this.edit_when_resend_dialog = false;
                        this.edit_when_resend_loader = false;
                    }
                    if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.edit_when_resend_dialog = false;
                        this.edit_when_resend_loader = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    this.init_loader = false
                    this.get_ay_std();
                    this.fetchNotices();
                    this.edit_when_resend_dialog = false;
                    this.edit_when_resend_loader = false;
                });
        },
        matchesSearch(value, query) {
            // Implement your custom filtering logic here
            const searchString = query.toLowerCase();

            // For example, you can check if the title or description contains the search query:
            const title = value[0].toLowerCase();
            const description = value[1].toLowerCase();

            return title.includes(searchString) || description.includes(searchString);
        },
        fetchNotices() {
            this.init_loader = true;
            const formData = {
                comm_type: "Notice",
                for: "all",
                fromdate: this.fromdate,
                todate: this.todate,
                ay: this.academicyear.id,
            };
            axios
                .post("/Communication/getNoticesBetweenDates", formData)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.d_ay = res.data.d_ay;
                        this.from_date = res.data.from_date;
                        this.to_date = res.data.to_date;
                        this.communication_list = res.data.communication_list;
                        this.cum_list = res.data.cum_list;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.init_loader = false;
                });
        },
        async deleteCommnByMsgId(key) {
            this.delete_loader = true;
            const formdata = {
                key: key,
            };
            try {
                const res = await axios.post("/communication/deleteCommnByMsgId", formdata);
                console.log(res.data.flag);
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", res.data.snackbar);
                    this.get_ay_std();
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.delete_loader = false;
            } catch (err) {
                console.log("err", err);
                this.showSnackbar("red", "Something went wrong!!!");
                this.delete_loader = false;
            } finally {
                console.log("bye...");
                this.delete_loader = false;
                this.fetchNotices();
            }
        },

        getDescription(description) {
            this.show_description = description;
            this.description_dialog = true;
        },
        deleteAttachment(attach) {
            const formData = {
                attach_id: attach.attach_id,
            };
            this.delete_acttach_load = true;
            axios
                .post("/communicationType/deleteAttachment", formData)
                .then((res) => {
                    if (res.data.status == "YES") {
                        const index = this.editedItem.attachment_list.indexOf(attach);
                        this.editedItem.attachment_list.splice(index, 1);
                        this.delete_acttach_load = false;
                        this.showSnackbar("green", "Attachment Deleted Successfully...");
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                        //alert(res.data.status_reason)
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.delete_acttach_load = false;
                });
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.communication_list.map((d) => d[val]);
        },
        clearData() {
            (this.division = []), (this.stream = ""), (this.title = ""), (this.link = ""), (this.description = ""), (this.attachments = []);
            this.standard = [];
            this.academicyear = null;
        },
        getStatus(id) {
            const formData = {
                comm_id: id,
            };
            axios
                .post("/Communication/getcommunicationStatus", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.comm_read_status = res.data.read_list;
                        this.status_dialog = true;
                        this.total_receipients = res.data.total_receipients;
                    }
                    if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.status_dialog = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => { });
        },
        save() {
            this.edit_save_attachment_load = true;
            let formData = new FormData();
            for (var i = 0; i < this.edit_attachments.length; i++) {
                let file = this.edit_attachments[i];

                formData.append("files", file);
            }
            formData.append("title", this.editedItem.title);
            formData.append("link", this.editedItem.url);
            formData.append("description", this.editedItem.description);
            formData.append("comm_id", this.editedItem.id);
            axios
                .post("/communicationType/saveEditCommunication", formData)
                .then((res) => {
                    if (res.data.status == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Notice Updated Successfully..."); // show snackbar on success
                        this.edit_dialog = false;
                        this.get_ay_std();
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                        //alert(res.data.status_reason)
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.edit_save_attachment_load = false;
                    this.edit_attachments = [];
                    this.close();
                    this.edit_dialog = false;
                });
        },
        editDialog(item) {
            this.awspath = localStorage.getItem("awspath");
            this.editedItem = item;
            this.edit_dialog = true;
            this.editItemIndex = this.notice_list.indexOf(item);
            //alert(this.editItemIndex)
        },
        editwhenresendDialog(item) {
            this.awspath = localStorage.getItem("awspath");
            this.editedItem = item;
            this.edit_when_resend_dialog = true;
            //  this.editItemIndex = this.notice_list.indexOf(item);
            //alert(this.editItemIndex)
        },
        validateWebinarURL(link) {
            // alert("validateWebinarURL::" + link);

            var myURL = link;
            var mytrimurl = myURL.trim();
            var pattern = new RegExp(
                "^((ft|htt)ps?:\\/\\/)?" + // protocol
                "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
                "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
                "(\\:\\d+)?" + // port
                "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
                "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
                "(\\#[-a-z\\d_]*)?$",
                "i"
            ); // fragment locator');
            if (this.hasWhiteSpace(this.myURL)) {
                this.isvalid = true;
                return;
            } else if (pattern.test(mytrimurl)) {
                this.isvalid = true;
                return;
            } else {
                this.isvalid = false;
                alert("Please Enter Valid URL...!");

                return;
            }
        },
        get_divisions_stream(stream, type) {
            if (type == "stream") {
                const formData = {
                    ay: this.academicyear.id,
                    stream: stream.id,
                };
                this.division = [];
                this.selected_all_division = false;
                axios
                    .post("/Communication/get_stream_divisions", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.division_list = res.data.division_list;
                            this.division_list = res.data.division_list.filter(
                                item => item.divname !== "ALL"
                            );
                            // this.standard_list=res.data.standard_list;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.standard = [];
                    });
            }
            if (type == "standard") {
                const formData = {
                    ay: this.academicyear.id,
                    standard: stream,
                };
                this.division = [];
                axios
                    .post("/Communication/get_standard_divisions", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.division_list = res.data.division_list;
                            this.division_list = res.data.division_list.filter(
                                item => item.divname !== "ALL"
                            );
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.stream = "";
                    });
            }
        },

        hasWhiteSpace(s) {
            var status = false;
            var reWhiteSpace = new RegExp(/^\s+$/);

            // Check for white space
            if (reWhiteSpace.test(s)) {
                // alert("Please Check Your Fields For Spaces");
                return true;
            }
            return false;
        },

        putCalendar() {
            //alert(this.academicyear.id)
            // alert(this.standard,length)
            if (this.hasWhiteSpace(this.title) || this.title == null) {
                this.showSnackbar("#b71c1c", "Please Enter Title");
                return;
            }

            this.send_btn_load = true;
            let formData = new FormData();
            for (var i = 0; i < this.attachments.length; i++) {
                let file = this.attachments[i];
                formData.append("files", file);
            }
            // Add division
            formData.append("div", JSON.stringify(this.division));

            // Add standard
            formData.append("standard", JSON.stringify(this.standard));
            formData.append("ay", this.academicyear.id);
            formData.append("stream", this.stream.id);
            // formData.append("standard", this.standard);
            formData.append("title", this.title);
            formData.append("link", this.link);
            formData.append("description", this.description);
            formData.append("type", "Notice");
            axios
                .post("/Communication/putNoticeHWAlbum", formData, {})
                .then((res) => {
                    if (res.data.msg == "200") {
                        if (res.data.status == "SUCCESS") {
                            // alert("Success");
                            this.showSnackbar("#4caf50", "Notice Added Successfully..."); // show snackbar on success
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                            //alert(res.data.status_reason);
                        }
                        //this.get_calendar();
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.send_btn_load = false;
                    this.get_ay_std();
                    this.clearData();
                    this.fetchNotices();
                });
        },
        get_ay_std() {
            this.init_loader = true;
            const formData = {
                comm_type: "Notice",
                for: "all",
            };
            axios
                .post("/Communication/gerInitialData", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.d_ay = res.data.d_ay;
                        //this.from_date = res.data.from_date;
                        //this.to_date = res.data.to_date;
                        //this.communication_list = res.data.communication_list;
                        //this.cum_list = res.data.cum_list;
                        (this.ay_list = res.data.ay_list), (this.academicyear = res.data.current_ay);
                        // this.stream_list=res.data.stream_list
                        this.stream_list = res.data.stream_list_all;
                        this.standard_list_all = res.data.standard_list_all;
                        this.standard_list_all = res.data.standard_list_all.filter(
                            item => item.standard !== "All"
                        );
                        this.isvalid = res.data.isvalid,
                            this.Message = res.data.Message
                    } else if (res.data.flag == "No") {
                        this.d_ay = res.data.d_ay;
                        (this.ay_list = res.data.ay_list),
                            (this.academicyear = res.data.current_ay);
                        this.stream_list = res.data.stream_list_all;
                        this.standard_list_all = res.data.standard_list_all;
                        this.standard_list_all = res.data.standard_list_all.filter(
                            item => item.standard !== "All"
                        );
                        this.isvalid = res.data.isvalid,
                            this.Message = res.data.Message
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.init_loader = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        deleteCalendarEvent(item) {
            this.delete_attach_load = true;
            //alert(item.id)
            if (!confirm("Are You Sure You Want To Delete This Communication?")) return;
            const formData = {
                comm_id: item.id,
            };
            axios
                .post("/communicationType/deleteCommunication", formData)
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.showSnackbar("#4caf50", res.data.status_reason); // show snackbar on success
                        //alert(res.data.status_reason)
                        const index = this.event_type.indexOf(item);
                        //this.event_type.splice(index, 1);
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                        //alert(res.data.status_reason)
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.delete_attach_load = false;
                    this.fetchNotices();
                    this.get_ay_std();
                });
        },
    },
    mounted() {
        this.init_loader = true;
        this.get_ay_std();
        this.basepath = localStorage.getItem("awspath");
        this.view = "Single";
    },
    computed: {
        bookList1() {
            if (this.communication_list.length == 0) return;
            return this.communication_list.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },

        // filteredData() {
        //           return this.cum_list.filter((item) => {
        //               const searchTerm = this.search.toLowerCase();
        //               if (item.title.toLowerCase().includes(searchTerm)) {
        //                   return item.title.toLowerCase().includes(searchTerm);}
        //                   else if(item.description.toLowerCase().includes(searchTerm)){
        //                       return item.description.toLowerCase().includes(searchTerm);
        //                   }

        //           });
        // },
    },
};
</script>
<style scoped>
.notice-card {
    border-radius: 16px;
    transition: 0.25s;
    /* border-left:6px solid #1976D2; */
}

.notice-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 18px rgba(0, 0, 0, .12) !important;
}

.allot-btn,
.allot-icon,
.info-icon {
    transition: 0.3s;
}

.allot-btn:hover .allot-icon {
    color: white;
}

.allot-btn:hover {
    background-color: #193a9a !important;
    border-color: #193a9a !important;
    color: white;
}

.info-icon:hover {
    background-color: #193a9a !important;
    border-color: #193a9a !important;
    color: white;
    border-radius: 100%;
}

.table-sub-title {
    margin-left: 1%;
    font-weight: 500;
    color: #999;
}

@media print {
    body {
        height: 100%;
        width: 100%;
    }

    .no-display {
        display: none !important;
    }

    .v-data-footer,
    .v-data-footer__select,
    .v-data-footer__pagination {
        display: none !important;
        visibility: hidden !important;
    }

    .v-data-table table,
    .v-data-table__wrapper {
        width: 100% !important;
        display: block !important;
    }

    table,
    th,
    td {
        border-collapse: collapse !important;
        border: 1px solid black !important;
        width: 100%;
        text-align: right !important;
    }
}

.box1 {
    height: 100%;
}
</style>